import { supabase } from './supabase';

let cachedOrg = null;

export async function getCurrentOrg() {
  if (cachedOrg) return cachedOrg;

  const { data: { user } } = await supabase?.auth?.getUser();
  if (!user) return null;

  const { data: profile } = await supabase
    ?.from('user_profiles')
    ?.select('organization_id, organizations(id, name, slug)')
    ?.eq('id', user?.id)
    ?.single();

  cachedOrg = profile?.organizations || null;
  return cachedOrg;
}

export async function getCurrentOrgId() {
  const org = await getCurrentOrg();
  return org?.id || null;
}

export async function getCurrentOrgName() {
  const org = await getCurrentOrg();
  return org?.name || null;
}

export function clearCachedOrg() {
  cachedOrg = null;
}

// Backward-compatible alias
export function clearCachedOrgId() {
  clearCachedOrg();
}
